import { useNavigate } from 'react-router-dom';
import { Heart, Check, Thermometer } from 'lucide-react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { useAuth } from '../context/AuthContext';
import PropertyBar from './PropertyBar';

export const MaterialCard = ({ material, onSelect, selected, onFavorite, isFavorite, showDetails = true }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Card
      className={`material-card card-trace cursor-pointer ${selected ? "selected" : ""}`}
      onClick={() => onSelect?.(material)}
      data-testid={`material-card-${material.id}`}
    >
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="text-lg">{material.name}</CardTitle>
            <CardDescription className="font-mono text-xs mt-1">
              {material.brand}
            </CardDescription>
          </div>
          <div className="flex items-center gap-2">
            <Badge variant="outline" className="badge-industrial">
              {material.category}
            </Badge>
            {user && onFavorite && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onFavorite(material.id);
                }}
                className={`p-1 transition-colors ${isFavorite ? "text-red-500" : "hover:text-[#1a8ccc]"}`}
                data-testid={`favorite-btn-${material.id}`}
              >
                <Heart className={`w-4 h-4 ${isFavorite ? "fill-current" : ""}`} />
              </button>
            )}
          </div>
        </div>
      </CardHeader>
      {showDetails && (
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground line-clamp-2">{material.description}</p>

          <div className="grid grid-cols-2 gap-3">
            <PropertyBar value={material.tensile_strength} label="Resistencia" />
            <PropertyBar value={material.flexibility} label="Flexibilidad" />
            <PropertyBar value={material.heat_resistance} label="Temp. Máx" />
            <PropertyBar value={material.chemical_resistance} label="Res. Química" />
          </div>

          <div className="flex items-center justify-between pt-2 border-t border-border">
            <span className="font-mono text-lg">€{material.price_per_kg}/kg</span>
            <div className="flex items-center gap-1">
              <Thermometer className="w-4 h-4 text-muted-foreground" />
              <span className="text-sm text-muted-foreground">
                {material.print_temp_min}-{material.print_temp_max}°C
              </span>
            </div>
          </div>
        </CardContent>
      )}
      {selected && (
        <CardFooter className="pt-0">
          <div className="flex items-center gap-2 text-[#1a8ccc]">
            <Check className="w-4 h-4" />
            <span className="text-sm font-medium">Seleccionado</span>
          </div>
        </CardFooter>
      )}
    </Card>
  );
};

export default MaterialCard;
